var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PENDING",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27756",
    "data-name": "Path 27756",
    d: "M17,31A14,14,0,1,1,31,17,14,14,0,0,1,17,31ZM17,5.154A11.846,11.846,0,1,0,28.846,17,11.846,11.846,0,0,0,17,5.154Z",
    transform: "translate(-3 -3)",
    fill: "#e2b438"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37965",
    "data-name": "Group 37965",
    transform: "translate(12.253 6.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_456",
    "data-name": "Line 456",
    d: "M.456,9.872A1.156,1.156,0,0,1-.7,8.716V.456a1.156,1.156,0,0,1,2.313,0V8.716A1.156,1.156,0,0,1,.456,9.872Z",
    transform: "translate(0.7 0.7)",
    fill: "#e2b438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_457",
    "data-name": "Line 457",
    d: "M3.761,6.568A1.155,1.155,0,0,1,2.8,6.053L-.506,1.1A1.156,1.156,0,0,1,1.418-.185l3.3,4.956a1.156,1.156,0,0,1-.961,1.8Z",
    transform: "translate(0.7 8.959)",
    fill: "#e2b438"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.2de3f4b0272bd084cd646ac73efdbf0f.svg";
export { ForwardRef as ReactComponent };